import React from "react";
import { connect } from "react-redux";

//component
import UserList from "../../../../user/userHaveAsset/helper/component/UserList.js";

//icon toggler
//import IconToggler from "../../../components/Icon/";

class UserHaveAsset extends React.Component {
  
  render() {
    return (
      <div className="animated fadeIn">
        <div className="row">
          {/* START Book a tool */}
          <div className="col-md-12">
            <div className="card">
              <UserList UserReducer={this.props.UserReducer} history={this.props.history}/>
            </div>
          </div>
          {/* END */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log(state)
  return {
    //Reducer: state.UserModelReducer,
    UserReducer: state.UserReducer,
    // RequestReducer: state.RequestReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    RunRedux: data => {
      dispatch(data);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserHaveAsset);



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/user/user_have_asset.js